import { render, staticRenderFns } from "./SummaryEstimateItem.vue?vue&type=template&id=b3aebea8&scoped=true&"
import script from "./SummaryEstimateItem.vue?vue&type=script&lang=js&"
export * from "./SummaryEstimateItem.vue?vue&type=script&lang=js&"
import style0 from "./SummaryEstimateItem.vue?vue&type=style&index=0&id=b3aebea8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3aebea8",
  null
  
)

export default component.exports